module.exports = __webpack_public_path__ + "img/Diverse.71a099da.jpg";